import React, { useState } from 'react'
import styled from '@emotion/styled'
import Loading from 'components/Utils/Loading'
import { useQuery } from '@apollo/client'
import { GET_AUTH_URL } from './queries'
import { PartnerName } from 'components/Integrations/constants'
import { StepStatus } from 'hooks/useStep'
import { Section } from 'components/Common'
import { CommonButton } from 'components/Common'

const ConnectSection = () => {
  const [authUrl, setAuthUrl] = useState<string | null>(null)

  const { loading: loadingAuthUrl } = useQuery(GET_AUTH_URL, {
    variables: { partnerName: PartnerName.LIGHTSPEED },
    onCompleted: (data) => {
      setAuthUrl(data?.getOauthAuthorizationUrl || null)
    }
  })

  if (loadingAuthUrl) {
    return <Loading />
  }

  return (
    <Root>
      <Section
        title='Choose a business to connect'
        description='You will be able to select locations and menus from this business in the next steps. To change the business, you must remove all store connections.'
        stepStatus={StepStatus.active}
        stepNumber={1}
        action={
          <CommonButton href={authUrl || ''} disabled={!authUrl}>
            Connect
          </CommonButton>
        }
      />

      <Card>
        <Item>
          <Title>Let’s get you ready to connect Lightspeed</Title>
          <Description>
            To connect your Lightspeed POS to Slerp, you’ll first need to
            contact Lightspeed and ask them to enable the Slerp integration on
            your account. You can follow the quick guide{' '}
            <a
              href='https://support.slerp.com/knowledge/how-do-i-connect-to-lightspeed-k-series'
              target='_blank'
              rel='noreferrer'
            >
              here
            </a>
            .
          </Description>
        </Item>
        <Item>
          <Title>Why connect your POS?</Title>
          <Description>
            When Slerp is linked to your Lightspeed POS, your online orders flow
            straight into your till. No double entry, no extra admin. It’s the
            simplest way to manage your Slerp online orders alongside your
            in-store sales, all in one place.
          </Description>
        </Item>
      </Card>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;

  a.ant-btn {
    padding-top: 5px !important;
  }
`

const Card = styled.div`
  padding: 24px 16px;

  border-radius: 4px;
  border: 1px solid #d2d2d9;
  margin: -1px;
  background-color: #ffffff;
`

const Item = styled.div`
  padding: 12px;
  border-bottom: 1px solid #d2d2d9;

  &:first-of-type {
    padding-top: 0px;
  }

  &:last-of-type {
    padding-bottom: 0px;
    border-bottom: none;
  }
`

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #4a4a68;
  margin-bottom: 4px;
`

const Description = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a68;
  line-height: 1.5;
  margin-bottom: 0;
`

export default ConnectSection
